import { useState, useEffect } from "react";
import { createColumnHelper } from "@tanstack/react-table";

import { Table } from "../../../../components/Table/Table";
import { handleDateFormat } from "../../../../utils/DateFormating";
import { twoDecimal, pascalCase } from "../../../../utils/display";
import "./InvoiceList.css";

export default function InvoiceList({
  contract,
  setSelectedInvoice,
  invoiceList,
}) {
  const [invoices, setInvoices] = useState(invoiceList || []);

  useEffect(() => {
    setInvoices(invoiceList);
  }, [invoiceList]);

  const goToRecord = (content) => {
    setSelectedInvoice(content);
  };

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.display({
      id: "view-invoice-offtaker",
      cell: (props) => (
        <button
          type="button"
          className="view-invoice-icon"
          onClick={() => {
            goToRecord(props.row.original);
          }}
          aria-label="View invoice details"
        >
          <img src={"/icons/visibility.svg"} alt="View" title="View" />
        </button>
      ),
      header: "",
    }),
    columnHelper.accessor("invoiceStartDate", {
      cell: (info) => handleDateFormat(info.getValue()),
      footer: (info) => info.column.invoiceStartDate,
      header: "Start Date",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("invoiceEndDate", {
      cell: (info) => handleDateFormat(info.getValue()),
      footer: (info) => info.column.invoiceEndDate,
      header: "End Date",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor(
      (row) => {
        if (contract.currency && row?.strikePrice)
          return `${row.strikePrice} ${contract.currency}`;
        return row.strikePrice || "";
      },
      {
        cell: (info) => `${info.getValue()}`,
        footer: (info) => info.column.id,
        header: "Strike price",
        enableGlobalFilter: false,
      },
    ),
    columnHelper.accessor("totalSuppliedVolume", {
      cell: (info) => `${twoDecimal(info.getValue())} MWh`,
      footer: (info) => info.column.id,
      header: "Volume",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("generatorCompensation", {
      cell: (info) => `${twoDecimal(info.getValue())} ${contract.currency}`,
      footer: (info) => info.column.generatorCompensation,
      header: "Generator Compensation",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("offTakerCompensation", {
      cell: (info) => `${twoDecimal(info.getValue())} ${contract.currency}`,
      footer: (info) => info.column.offTakerCompensation,
      header: "Offtaker Compensation",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("invoiceStatus", {
      cell: (info) => {
        const value = info.getValue() || "";
        return <span className={value.toLowerCase()}>{pascalCase(value)}</span>;
      },
      footer: (info) => info.column.id,
      header: "Status",
      enableGlobalFilter: false,
    }),
  ];

  const passedInvoices = invoices.filter((invoice) => {
    return invoice.invoiceStatus === "passed";
  });

  const failedInvoices = invoices.filter((invoice) => {
    return invoice.invoiceStatus === "failed";
  });

  return (
    <div className="invoice-list-container">
      <div className="invoice-count-container">
        <div className="invoice-count">
          <div className="invoice-count-text-container">
            <span className="invoice-count-text">Passed Invoices</span>
            <img src={"/icons/success.svg"} alt="success" />
          </div>
          <span className="invoice-count-text invoice-count-value">
            {passedInvoices.length}
          </span>
        </div>
        <div className="invoice-count">
          <div className="invoice-count-text-container">
            <span className="invoice-count-text">Failed Invoices</span>
            <img src={"/icons/failed.svg"} alt="failed" />
          </div>
          <span className="invoice-count-text invoice-count-value">
            {failedInvoices.length}
          </span>
        </div>
      </div>
      <div className="invoice-list">
        <Table
          columns={columns}
          data={invoices}
          setData={setInvoices}
          showGlobalSearch={false}
        />
      </div>
    </div>
  );
}
